<template>
    <div class="payments-wrapper">
        <div class="payments-convert">
            <em class="help-text">курс: {{rateBGNReduced || 'N/A'}}</em>
        </div>

        <ul class="payments" v-if="payments.length">
            <li class="payment" v-for="(payment, index) in payments">
                <a href="#" class="payment-remove" @click="removePayment(index)">
                    <i class="fa fa-remove"></i>
                </a>

                <div class="payment-cols">
                    <div class="payment-col">
                        <label>Заглавие:</label>

                        <input
                            type="text"
                            v-bind:name="`payments[${index}][title]`"
                            class="field"
                            id="title_field"
                            v-model="payment.name"
                            required
                        />
                    </div>

                    <div class="payment-col payment-col-small">
                        <label>Тип:</label>

                        <select
                            v-bind:name="`payments[${index}][type]`"
                            class="field"
                            v-model="payment.type"
                        >
                            <option value="standard">Standard</option>
                            <option value="express">Express</option>
                        </select>
                    </div>

                    <div class="payment-col payment-col-small">
                        <label>Сума(USD):</label>

                        <input
                            type="text"
                            v-bind:name="`payments[${index}][amount_usd]`"
                            autocomplete="off"
                            class="field"
                            v-model="payment.amountUSD"
                        />
                    </div>

                    <div class="payment-col payment-col-small">
                        <label>Сума в лева:</label>

                        <input
                            type="text"
                            v-bind:name="`payments[${index}][amount_bgn]`"
                            autocomplete="off"
                            class="field"
                            v-model="payment.amountBGN"
                        />
                    </div>

                    <div class="payment-col payment-col-small">
                        <label class="payment-payed">
                            <span>&nbsp;</span>

                            <input
                                type="checkbox"
                                v-bind:name="`payments[${index}][payed]`"
                                v-model="payment.payed"
                           /> Платено
                        </label>

                    </div>
                </div>

                <em v-if="payment?.currency?.toUpperCase() !== 'USD'">
                    Оригинална сума: {{ payment.amountOriginalCurrency }} {{ payment?.currency?.toUpperCase()}}
                </em>

                <input
                    type="hidden"
                    v-bind:name="`payments[${index}][presented_amount]`"
                    v-model="payment.amountOriginalCurrency"
                />

                <input
                    type="hidden"
                    v-bind:name="`payments[${index}][presented_currency]`"
                    v-model="payment.currency"
                />

            </li>
        </ul>

        <a href="#" class="button" @click.prevent="addPayment('', 0)">
            <i class="fa fa-plus-circle"></i> Добави още
        </a>
    </div>
</template>

<script>
export default {
    name: 'payments',

    data() {
        return {
            rates: {},
            payments: []
        };
    },

    props: {
        submitted: {
            default: true
        },

        defaultPayments: {
            default() {
                return [];
            }
        }
    },

    computed: {
        /**
         * Get the USD to BGN rate reduced by 1 percent to account
         * for currency convertion fees
         *
         * @return {Number}
         */
        rateBGNReduced() {
            return this.rates?.USD?.BGN?.toFixed(2);
        },
    },

    mounted() {
        this.$watch((vm) => [vm?.payments, vm?.rates], ([payments, rates]) => {
            const newPayments = this.calculatePayments(payments, rates);
            if (this.arePaymentsDifferent(this.payments, newPayments)) {
                this.payments = newPayments;
            }
        }, { deep: true });

        this.fetchRates();
    },

    methods: {
        fetchRates(base = 'USD', target = "BGN") {
            const vm = this;

            $.ajax({
                url: `/get-course?base=${base}&target=${target}`,
                method: 'GET',

                success(resp) {
                    vm.rates = {
                        ...vm.rates,
                        [base]: {
                            ...vm.rates[base],
                            [target]: resp
                        }
                    }
                }
            });
        },

        addPayment(name = '', price = 0, type = 'standard', currency = 'USD') {
            this.payments.push({
                name: name,
                amountOriginalCurrency: price,
                currency: currency,
                amountUSD: currency === 'USD' ? price : 0,
                amountBGN: 0,
                payed: false,
                type: type
            });
        },

        removePayment(index) {
            this.payments.splice(index, 1);
        },

        calculatePayments(payments, rates) {
            return payments.map(payment => {
                if (payment.currency !== 'USD' && rates[payment.currency]?.USD) {
                    payment.amountUSD = Math.round(payment.amountOriginalCurrency * rates[payment.currency].USD);
                }

                if (rates?.USD?.BGN) {
                    payment.amountBGN = Math.round(payment.amountUSD * rates.USD.BGN);
                }

                return payment;
            });
        },

        arePaymentsDifferent(payments1, payments2) {
            if (payments1?.length !== payments2?.length) {
                return true;
            }

            for (let i = 0; i < payments1.length; i++) {
                const payment1 = payments1[i];
                const payment2 = payments2[i];

                if (payment1?.amountUSD !== payment2?.amountUSD || payment1?.amountBGN !== payment2?.amountBGN) {
                    return true;
                }
            }

            return false;
        }
    },

    watch: {
        submitted(isSubmitted) {
            if (isSubmitted) {
                this.payments = [];
            }
        },

        defaultPayments(newVal) {
            for (let i = 0; i < newVal.length; i++) {
                const defaultPayment = newVal[i];

                this.addPayment(
                    defaultPayment.name,
                    defaultPayment.price,
                    defaultPayment.type,
                    defaultPayment.currency,
                );
            }

            const usedCurrencies = newVal
                .filter(p => p?.currency?.toUpperCase() !== 'USD')
                .map(p => p.currency);

            const uniqueCurrencies = [... new Set(usedCurrencies)];

            for (let i = 0; i < uniqueCurrencies.length; i++) {
                this.fetchRates(uniqueCurrencies[i], 'USD');
            }

        }
    }
}
</script>

<style scoped>
    .payments { padding: 10px 0; list-style: none outside none; }
    .payments-convert { font-size: .9em; }
    .payments-convert input { display: inline-block; vertical-align: middle; }

    .payment { position: relative; margin-bottom: 10px; padding-right: 25px; }
    .payment:last-child { margin-bottom: 0; }

    .payment-remove { position: absolute; right: 0; bottom: 0; color: #c90000; }
    .payment-remove i { height: 32px; line-height: 32px; }

    .payment-cols { margin: 0 -10px; }
    .payment-cols:after { content: ''; display: table; clear: both; line-height: 0; }
    .payment-col { float: left; width: 33.33%; padding: 0 10px; box-sizing: border-box; }
    .payment-col-small { width: 16.6667%; }

    .payment-payed span { display: block; margin-bottom: 9px; }
</style>
